<template>
  <v-card
    flat
    outlined
    tile
  >
    <v-card-title v-if="!saleSet">Shares</v-card-title>
    <v-card-title v-else>Total Shares: {{ adminAsset.totalShares }}</v-card-title>
    <v-card-subtitle v-if="!saleSet">Be sure that you are done editing/updating the asset detials before you begin the sale. <span class="red--text">You will not be able to edit this asset once you begin the sale.</span></v-card-subtitle>
    <v-card-subtitle v-else>The sale has already begun for this item.</v-card-subtitle>

    <v-card-text class="pb-0">
      <v-row v-if="!saleSet">
        <v-col md="6">
          <v-text-field
            v-model.number="saleDetails.totalShareCount"
            label="Total Number of Shares"
            @input="saleInputCheck"
          ></v-text-field>
        </v-col>

        <v-col md="6">
          <v-text-field
            v-model.number="perSharePrice"
            label="Price Per Share"
            :messages="'Total Shares Price: $' + saleDetails.totalSharePrice"
            prefix="$"
            @input="saleInputCheck"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <!-- Preferred Purchase -->
          <v-radio-group
            v-model="saleDetails.preferredPurchaseSource"
            mandatory
          >
            <template v-slot:label>
              <div>Preferred Purchase Source</div>
            </template>
            <v-radio
              label="BCC"
              :value="0"
            ></v-radio>
            <v-radio
              label="Consignor"
              :value="1"
            ></v-radio>
          </v-radio-group>
        </v-col>

        <v-col md="6">
          <!-- Escrow Percentage -->
          <v-text-field
            v-model.number="saleDetails.escrowPercentage"
            label="Escrow Percentage"
            suffix="%"
            @input="saleInputCheck"
          ></v-text-field>
        </v-col>
      </v-row>

    </v-card-text>

    <v-card-actions v-if="!saleSet">
      <v-btn
        color="primary"
        :loading="saleLoading"
        :disabled="saleDisable"
        @click="setSale"
      >
        <v-icon left>
          mdi-cash-multiple
        </v-icon>
        Begin Sale
      </v-btn>

      <v-btn
        v-if="this.$route.name !== 'flipItemEdit'"
        @click="$emit('dialog-close')"
      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "AssetBeginSaleForm",

    computed: {
      ...mapGetters([
        'adminAsset',
      ]),

      saleSet: function () {
        return this.adminAsset.salesState !== 'DataEntry'
      }
    },

    data: () => ({
      // Form helpers
      saleLoading: false,
      saleDisable: true,
      perSharePrice: null,

      // Payload.
      saleDetails: {
        preferredPurchaseSource: 1,
        escrowPercentage: 10,
        totalShareCount: null,
        totalSharePrice: null
      }
    }),

    methods: {
      ...mapActions([
        'beginSale'
      ]),

      // Input check to toggle the begin sale button.
      saleInputCheck: function () {
        this.saleDetails.totalSharePrice = this.perSharePrice * this.saleDetails.totalShareCount

        // if(isNaN(this.saleDetails.escrowPercentage)) {
        //   this.escrowPercentage = 0;
        // }

        if (this.saleDetails.totalShareCount === null
          || this.perSharePrice === null
          || this.saleDetails.escrowPercentage === null
          || this.saleDetails.escrowPercentage < 0
          //|| isNaN(this.saleDetails.escrowPercentage)
          ) {
          this.saleDisable = true
        }
        else {
          this.saleDisable = false
        }
      },

      // Begin the sale!
      setSale: function () {
        this.saleLoading = true
        this.saleDisable = false

        this.beginSale({
          assetId: this.adminAsset.id,
          saleDetails: this.saleDetails
        }).then(() => {
          console.log('the sale is set')
          this.saleLoading = false
          this.$emit('dialog-close')
        }).catch(() => {
          this.saleLoading = false
          this.saleDisable = true
        })
      }
    },
  }
</script>
